// generic modal to answer yes/no

import { getModalStyle } from '@/utils/Modal';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

//import IconButton from '@mui/material/IconButton';
import {
    Check as YesIcon,
    Close as NoIcon
} from '@mui/icons-material';
//import Button from '@/components/Button';

export default function BooleanModal({open, setOpen, title, text, handleAnswer, fullScreen}){

	const { sxDialog/*, sxCloseIcon*/ } = getModalStyle();

    const handleClose = () => setOpen(false);

    return (
        
        <Dialog
            container={fullScreen?.active ? fullScreen?.node?.current : null}
            sx={sxDialog}
            onClose={handleClose}
            open={open}
            fullWidth={true}
            maxWidth='sm'
        >
        	<DialogTitle className='modal-title'>
                {title}
            </DialogTitle>
            {/*
            <IconButton                    
                onClick={handleClose}
                sx={sxCloseIcon}
            >
                <CloseIcon />
            </IconButton> 
            */}
            <DialogContent className='modal-content text-center'>
                {text}
            </DialogContent>
        	<div className="modal-buttons">
                <div className='me-1'>
                    <YesIcon className='action-button-modal text-green-800' onClick={(e) => handleAnswer(e,true)}/>
                </div>
                <div className=''>
                    <NoIcon className='action-button-modal text-red-600' onClick={(e) => handleAnswer(e,false)}/>
                </div>
            </div>
        </Dialog>
  );
}